import api from "@/api";
import {
  AgencyType,
  CustomerAgencyType,
  MAPAccountStatusEnum,
  ProductTypeEnum,
} from "./common_enum";
import { getLocalStorage } from "./common";

const LeadGenList = [5];

export const getDefaultRouter = (
  customerType = 0,
  defaultPath = "",
  search = "",
  basePath = "dashboard"
) => {
  return `/${
    customerType === CustomerAgencyType.BillingAgency ? defaultPath : basePath // "dashboard"
  }${search}`;
};

export const isACustomerAgency = (customerType: number) => {
  return Number(customerType) === CustomerAgencyType.BillingAgency;
};

export const isAgency = (isClonedUser: any, roleId: any, agencyType: any) => {
  return isClonedUser && roleId === 1 && agencyType === AgencyType.Agency;
};

export const ToCNY = (
  data: number | null | undefined,
  currency = "CNY"
): string => {
  if (data === null || data === undefined || isNaN(Number(data))) {
    return "";
  }

  try {
    const formattedValue = Number(data).toLocaleString(
      currency === "CNY" ? "zh" : "en-us",
      {
        style: "currency",
        currency,
        maximumFractionDigits: 2,
      }
    );
    return `${formattedValue} (${currency})`;
  } catch (error) {
    console.warn(
      `Currency formatting failed for value: ${data}, currency: ${currency}`,
      error
    );
    return `${data} (${currency})`;
  }
};

export const ToPercent = (data: any) => {
  return data?.toLocaleString("zh", {
    style: "percent",
    useGrouping: true,
    minimumFractionDigits: 2,
  });
};

export const verifyProduct = (product: number, primaryPurpose: number) => {
  return (
    product === ProductTypeEnum.LeadGen && LeadGenList.includes(primaryPurpose)
  );
};

export const getBasePath = (
  product: number,
  primaryPurpose: number,
  path1 = "campaign",
  path2 = "dashboard"
) => {
  return verifyProduct(product, primaryPurpose) ? path1 : path2;
};

export const formatNum = (value: any) => {
  return parseFloat(value).toLocaleString("zh-cn", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  });
};
export const callContent = (val: any) => {
  if (
    Object.prototype.toString.call(val) !== "[object Object]" &&
    !val?.label
  ) {
    return `${val || ""}`;
  }
  return val?.label;
};

export const parseColor = (str: any) => {
  let reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
  if (!reg.test(str)) {
    return;
  }
  // eslint-disable-next-line no-useless-escape
  let newStr = str.toLowerCase().replace(/\#/g, "");
  let len = newStr.length;
  if (len === 3) {
    let t = "";
    for (let i = 0; i < len; i++) {
      t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
    }
    newStr = t;
  }
  const r = parseInt(newStr.slice(0, 2), 16);
  const g = parseInt(newStr.slice(2, 4), 16);
  const b = parseInt(newStr.slice(4, 6), 16);
  return { r, g, b };
};
export const getLuminance = (bgColor: any) => {
  return Math.round(0.299 * bgColor.r + 0.587 * bgColor.g + 0.114 * bgColor.b);
};

export const getBackgroundColor = (bgColor: any) => {
  return `linear-gradient(rgb(${bgColor.r}, ${bgColor.g}, ${bgColor.b}),rgb(${bgColor.r}, ${bgColor.g}, ${bgColor.b}) 16px,rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, 0.85) 64px,rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, 0.6) 100px,rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, 0) 170px,rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, 0))`;
};

export const getTemplateItem = async (templateId: any) => {
  const result: any = await api.GetDoc.getTemplatePic({ templateId });
  let blob = new Blob([result], { type: "image" });
  let url = window.URL.createObjectURL(blob);
  return url;
};

export function blobToDataURI (blob: any, callback: any) {
  let reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = (e: any) => {
    callback(e.target.result);
  };
}

export const findElement = (
  data: Array<any>,
  prominenceType: string,
  name: string
) => {
  return data?.find(
    (element) =>
      element.ProminenceType === prominenceType && element.Name === name
  );
};

export const getLeftValue = (backgroundImageOriginalMediaWidth: number) => {
  return backgroundImageOriginalMediaWidth - 600;
};

export const jsonParse = (element: string) => {
  return JSON.parse(element, (key, value) => {
    if (typeof value === "string") {
      return value.replace(/&/g, "&amp;");
    }
    return value;
  });
};

export const goToMap = () => {
  window.open("https://ads.microsoft.com/", "_blank");
};

export const getMAP_Account_Stutus = () => {
  return (
    Number(getLocalStorage("MAPAccountStatus")) ===
    MAPAccountStatusEnum.AbnormalTimeout
  );
};

export const toCurrencyWithoutSuffix = (
  data: number | null | undefined,
  currency = "CNY"
): string => {
  if (data === null || data === undefined || isNaN(Number(data))) {
    return "";
  }

  try {
    return Number(data).toLocaleString("zh", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    });
  } catch (error) {
    console.warn(
      `Currency formatting failed for value: ${data}, currency: ${currency}`,
      error
    );
    return String(data);
  }
};
